import TabsLayout from "$src/core/components/templates/TabsLayout";

const TAB_SLOT_ROUTES = [
  "(slot-1)/[slug]",
  "(slot-2)/[slug]",
  "(slot-3)/[slug]",
  "(slot-4)/[slug]",
  "(slot-5)/[slug]",
  "(slot-6)/[slug]",
  "(slot-7)/[slug]",
];

const Layout: React.FC = () => <TabsLayout routes={TAB_SLOT_ROUTES} />;

export default Layout;
